/**
 * 书架拖拽状态渲染模块
 */

export function updateBookshelfDragState(state, elements) {
  const shouldEnable = state?.sortBy === 'custom' && !state?.isSelectMode;
  elements?.booksGrid?.classList.toggle('is-custom-sort', shouldEnable);

  elements?.booksGrid?.querySelectorAll('.book-card, .book-list-item').forEach(el => {
    if (shouldEnable) {
      el.removeAttribute('draggable');
    } else {
      el.removeAttribute('draggable');
      el.classList.remove('dragging', 'drag-over');
      el.style.opacity = '';
    }
  });

  const shouldEnableCollections = state?.sortBy === 'custom' &&
    !state?.isSelectMode &&
    state?.filterCollection === 'all';

  elements?.booksGrid?.querySelectorAll('.collection-card:not(.collection-card--action), .collection-list-item:not(.collection-list-item--action)').forEach(el => {
    if (shouldEnableCollections) {
      el.removeAttribute('draggable');
    } else {
      el.removeAttribute('draggable');
      el.classList.remove('dragging', 'drag-over');
      el.style.opacity = '';
    }
  });
}
